import React, { useRef, useState, useEffect, useContext } from "react";
import {
  ErxAdviceContext,
  ErxAdviceDispatchContext,
} from "../../context/ErxContext";
import { Card, Form, Row, Col, Dropdown, Button, Table } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import Loading from "../../shared/Loading.js";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { set } from "lodash";

function ErxReferels({ id, newEntryForm = true }) {
  const data = [
    { name: "Paracetamol", type: "medicine" },
    { name: "Pacimol", type: "medicine" },
    { name: "Survolin", type: "medicine" },
    { name: "Metrogyl", type: "medicine" },
    { name: "Eno", type: "medicine" },
    { name: "Altroxin", type: "medicine" },
    { name: "Hemoglobin", type: "tests" },
    { name: "TSH", type: "tests" },
    { name: "Stool", type: "tests" },
    { name: "ECG", type: "tests" },
    { name: "USG", type: "tests" },
    { name: "MRI", type: "tests" },
  ];
  const [isLoading, setIsLoading] = useState(true);

  const variant = "success";
  const key = "Referels".replace(/ /g, "_");
  const referelNoted = useContext(ErxAdviceContext);
  const setReferelNoted = useContext(ErxAdviceDispatchContext);
  const [referelData, setReferelData] = useState({
    referelType: "internal",
    referFrom: [],
    referTo: [],
    referelDate: "",
  });
  const referelRef = useRef({});
  //const [referelNoted, setReferelNoted] = useState([]);
  useEffect(() => {
    if (!referelNoted[key]) {
      setReferelNoted({ type: "init", key: key });
    }
    setIsLoading(false);
  }, []);
  const addReferel = () => {
    let fileList = referelRef.current["files"].files;
    let newData = {
      ...referelData,
      timeStamp: Date.now(),
      files: [...fileList],
    };
    if (newData.referelType === "inbound") newData.referTo = [];
    else newData.referFrom = [];
    setReferelNoted({ type: "add", key: key, data: newData });
    setReferelData({
      referelType: "internal",
      referFrom: [],
      referTo: [],
      referelDate: "",
    });
    document.getElementById("referel-form").reset();
  };

  const [expandedRows, setExpandedRows] = useState([]);
  // State variable to keep track which row is currently expanded.
  const [expandState, setExpandState] = useState({});
  const [editSelected, setEditSelected] = useState({});

  return (
    <Card className="mb-3 rounded-0" border={variant} id={id}>
      <Card.Header
        as="h5"
        className={`rounded-0 bg-${variant} text-white print-black`}
      >
        Referels
      </Card.Header>
      <Card.Body>
        {isLoading === true ? (
          <Loading />
        ) : isLoading === "error" ? (
          <Loading failed={true} />
        ) : (
          <>
            {newEntryForm && (
              <form action="" id="referel-form">
                <fieldset className="d-print-none">
                  <Row sm={3}>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Type</Form.Label>
                        <Form.Select
                          value={referelData.referelType}
                          name="referel_type"
                          onChange={(e) => {
                            setReferelData({
                              ...referelData,
                              referelType: e.target.value,
                            });
                          }}
                        >
                          <option value="internal">Internal</option>
                          <option value="inbound">Inbound</option>
                          <option value="outbound">Outbound</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col>
                      {referelData.referelType === "internal" && (
                        <Form.Group className="mb-3">
                          <Form.Label>Refering To</Form.Label>
                          <Typeahead
                            labelKey="name"
                            onChange={(selected) => {
                              setReferelData({
                                ...referelData,
                                referTo: selected,
                              });
                            }}
                            options={data}
                            id="referToTypeAhead"
                            selected={referelData.referTo}
                          />
                        </Form.Group>
                      )}
                      {referelData.referelType === "inbound" && (
                        <Form.Group className="mb-3">
                          <Form.Label>Referred From</Form.Label>
                          <Typeahead
                            labelKey="name"
                            onChange={(selected) => {
                              setReferelData({
                                ...referelData,
                                referFrom: selected,
                              });
                            }}
                            options={data}
                            id="referFromTypeAhead"
                            selected={referelData.referFrom}
                          />
                        </Form.Group>
                      )}
                      {referelData.referelType === "outbound" && (
                        <Form.Group className="mb-3">
                          <Form.Label>Refering To</Form.Label>
                          <Typeahead
                            labelKey="name"
                            onChange={(selected) => {
                              setReferelData({
                                ...referelData,
                                referTo: selected,
                              });
                            }}
                            options={data}
                            id="referToTypeAhead"
                            selected={referelData.referTo}
                          />
                        </Form.Group>
                      )}
                    </Col>
                    <Col>
                      <Form.Group className="mb-3">
                        <Form.Label>Date</Form.Label>
                        <Form.Control
                          type="date"
                          value={referelData.referelDate}
                          onChange={(e) => {
                            setReferelData({
                              ...referelData,
                              referelDate: e.target.value,
                            });
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group className="mb-3">
                        <Form.Label>Files</Form.Label>
                        <Form.Control
                          type="file"
                          multiple
                          ref={(el) => (referelRef.current["files"] = el)}
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={12} className="text-end mb-3">
                      <Button
                        type="button"
                        variant={variant}
                        onClick={addReferel}
                      >
                        Add
                      </Button>
                    </Col>
                  </Row>
                </fieldset>
              </form>
            )}

            <Table bordered>
              <colgroup>
                <col style={{ width: "110px" }} />
                <col span={4} />

                <col style={{ width: "75px" }} className="d-print-none" />
              </colgroup>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Type</th>
                  <th>Date</th>
                  <th>Refer To</th>
                  <th>Refer From</th>
                  <th>Files</th>
                </tr>
              </thead>
              <tbody>
                {referelNoted[key].map((advice, index) => {
                  return (
                    <>
                      <tr
                        className={
                          expandState[advice.timestamp] === true
                            ? "table-warning"
                            : expandState[advice.timestamp] === "edit"
                            ? "table-danger"
                            : ""
                        }
                        key={advice.timestamp}
                      >
                        <td></td>
                        <td role="button">
                          <strong>{advice.referelType.toUpperCase()}</strong>
                        </td>

                        <td>{advice.referelDate}</td>
                        <td>
                          {advice.referTo.length > 0
                            ? advice.referTo[0].name
                            : ""}
                        </td>
                        <td>
                          {advice.referFrom.length > 0 &&
                            advice.referFrom[0].name}
                        </td>
                        <td>
                          {advice.files.length >= 1 && (
                            <Dropdown>
                              <Dropdown.Toggle
                                size="sm"
                                variant={variant}
                                id={`filelistbutton${advice.timestamp}`}
                              >
                                Files
                              </Dropdown.Toggle>

                              <Dropdown.Menu>
                                {Array.from(advice.files).map((file, index) => {
                                  return (
                                    <Dropdown.Item href="#/action-1">
                                      {file.name}
                                    </Dropdown.Item>
                                  );
                                })}
                              </Dropdown.Menu>
                            </Dropdown>
                          )}
                        </td>
                      </tr>
                      {expandedRows.includes(advice.timestamp) && (
                        <tr className="d-print-none">
                          <td colSpan={6}></td>
                        </tr>
                      )}
                    </>
                  );
                })}
              </tbody>
            </Table>
          </>
        )}
      </Card.Body>
    </Card>
  );
}

export default ErxReferels;
